import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { BlogPost } from '../types';
import BlogCard from './BlogCard';
import BlogModal from './BlogModal';
import { getBlogPostsData } from '../data/blog';

interface BlogProps {
  showAll?: boolean;
}

const Blog: React.FC<BlogProps> = ({ showAll = false }) => {
  const [selectedPost, setSelectedPost] = useState<BlogPost | null>(null);
  const [blogPosts, setBlogPosts] = useState<BlogPost[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const loadBlogPosts = async () => {
      try {
        setLoading(true);
        const posts = await getBlogPostsData();
        const sortedPosts = posts.sort((a, b) => {
          return new Date(b.date).getTime() - new Date(a.date).getTime();
        });
        setBlogPosts(showAll ? sortedPosts : sortedPosts.slice(0, 3));
      } catch (error) {
        console.error('Error loading blog posts:', error);
        setBlogPosts([]);
      } finally {
        setLoading(false);
      }
    };

    loadBlogPosts();
  }, [showAll]);

  const openPost = (post: BlogPost) => {
    setSelectedPost(post);
  };

  const closePost = () => {
    setSelectedPost(null);
  };

  return (
    <>
      <section id="blog" className="blog">
        <div className="container">
          <div className="section-header">
            <h2 className="section-title">
              {showAll ? 'All Blog Posts' : 'Recent Posts'}
            </h2>
            {!showAll && (
              <Link to="/blog" className="view-all-link">
                View All Posts →
              </Link>
            )}
          </div>
          {loading ? (
            <div className="loading-indicator">
              <p>Loading blog posts...</p>
            </div>
          ) : blogPosts.length > 0 ? (
            <div className="blog-grid">
              {blogPosts.map((post) => (
                <BlogCard key={post.id} post={post} onOpen={openPost} />
              ))}
            </div>
          ) : (
            <div className="no-posts-message">
              <p>No blog posts available at the moment.</p>
            </div>
          )}
        </div>
      </section>
      {selectedPost && (
        <BlogModal post={selectedPost} onClose={closePost} />
      )}
    </>
  );
};

export default Blog;